// Navigation shim — a thin, Next-compatible facade over the router.
//
// All feature code imports its navigation hooks from here instead of directly
// from `react-router` / `react-router-dom`. This is the single seam the Next.js
// port swaps (Phase 5.4): this file's implementation is repointed to
// `next/navigation`, and every call site is left untouched.
//
// The exposed surface deliberately matches Next's `next/navigation`:
//   - useNavigate() — imperative navigation (absorbs `navigate(-1)`; the Next
//                     impl will map the numeric delta onto `router.back()`).
//   - useParams()   — dynamic route params.
//   - useSearchParams() — the current query string as a `URLSearchParams`
//                     (Next returns the params directly, not react-router's
//                     `[params, setParams]` tuple — so we unwrap it here).
//   - usePathname() — the current pathname string.
//
// Only navigation *hooks* live behind this shim. The router *structure*
// (`BrowserRouter` / `Routes` / `Route` / `Navigate`) stays on react-router and
// is replaced when the route tree moves into `app/` (Phase 5.2/5.3).

export { useNavigate, useParams } from 'react-router-dom';

import {
  useSearchParams as useRouterSearchParams,
  useLocation,
} from 'react-router-dom';

export function useSearchParams(): URLSearchParams {
  return useRouterSearchParams()[0];
}

export function usePathname(): string {
  return useLocation().pathname;
}
